var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.breadCrumb },
    _vm._l(_vm.items, function (item, i) {
      return _c("span", { key: i, class: item.active && _vm.$style.active }, [
        _vm._v(" " + _vm._s(item.text) + " "),
        i !== _vm.items.length - 1
          ? _c("span", { class: _vm.$style.symbol }, [_vm._v(" > ")])
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }